import Field from 'quickfield/dist/field'
import ChoiceField,{Choice} from 'quickfield/dist/fields/choice'
import template,* as templates from './template'
import SimplyBind from '@danielkalen/simplybind'


class ChoiceStyleField extends Field
	template: template
	templates: templates
	defaults:
		size: 60
		perGroup: 3
	
	constructor: ()->
		super(arguments...)
		@_value ?= null
		@lastSelected = null
		@visibleChoicesCount = 0
		@choices = []
		
		@_createElements()
		@_attachBindings()
		@_constructorEnd()

	_getValue: ()->
		return @_value?.value

	_setValue: (newValue)->
		@setChoice(newValue)

	_createElements: ()->
		globalOpts = {related:@}
		@el = @template.spawn(@settings.templates.default, related:@)
		
		choices = @settings.choices
		perGroup = @settings.perGroup
		choiceGroups = Array(Math.ceil(choices.length/perGroup)).fill().map (s,index)-> choices.slice(index*perGroup, index*perGroup+perGroup)
		choiceGroups.forEach (choices, groupIndex)=>
			groupEl = @templates.choiceGroup.spawn(@settings.templates.choiceGroup, globalOpts).appendTo(@el.child.innerwrap)
			
			choices.forEach (data, index)=>
				choice = new Choice(@, data, index, groupIndex, groupEl)
				choice.el.applyData(data)
				@choices.push(choice)

		@el.child.innerwrap.raw._quickField = @

		return @el


	_attachBindings: ()->
		@_attachBindings_elState()
		@_attachBindings_stateTriggers()
		@_attachBindings_display()
		@_attachBindings_value()
		choice._attachBindings() for choice in @choices
		return

	
	_validate: (value)->
		return !!value
	

	@::_attachBindings_elState = ChoiceField::_attachBindings_elState
	@::_attachBindings_stateTriggers = ChoiceField::_attachBindings_stateTriggers
	@::_attachBindings_display = ChoiceField::_attachBindings_display
	@::_attachBindings_value = ChoiceField::_attachBindings_value
	@::setChoice = ChoiceField::setChoice
	@::findChoice = ChoiceField::findChoice
	@::findChoiceAny = ChoiceField::findChoiceAny


export default ChoiceStyleField